import server from "../integration/server/server-services";
import {NvdbSubmission} from "../integration/representation/nvdb-submission";
import {IPromise} from "angular";

export default class NvdbSubmissionList {

    private items: NvdbSubmission[] = [];
    private refresher: IPromise<any>;

    constructor(private readonly $interval: angular.IIntervalService,
                private readonly contractId: string,
                private readonly server: server,
                private readonly onChange: Function) {

        this.readNvdbSubmissions().then(function() {
            if (this.getNumInProgress() > 0) {
                this.startRefresher();
            }
        }.bind(this));
    }

    accept(nvdbSubmissions: NvdbSubmission[]) {
        this.items = nvdbSubmissions;
        if (!this.refresher && this.getNumInProgress() > 0) {
            this.startRefresher();
        }
    }

    destroy() {
        if (this.refresher) {
            this.stopRefresher();
        }
    }


    readNvdbSubmissions() {
        return this.server.listSubmittedNvdbRegistrations(this.contractId)
            .then(submissions => this.items = submissions);
    }

    getNumInProgress(): number {
        return this.items
            .filter(function(nvdbSubmission) {
                return nvdbSubmission.status === 'BEHANDLES' || nvdbSubmission.status === 'VENTER';
            }).length;
    }

    startRefresher(): void {
        const model = this;
        this.refresher = this.$interval(function() {
            const numTotalBefore = model.items.length;
            const numInProgressBefore = model.getNumInProgress();
            model.readNvdbSubmissions().then(function() {
                const numTotalAfter = model.items.length;
                const numInProgressAfter = model.getNumInProgress();
                if (numInProgressAfter === 0) {
                    model.stopRefresher();
                }

                // Only update submission status if something changed
                if (numTotalBefore != numTotalAfter || numInProgressAfter != numInProgressBefore) {
                    model.onChange();
                }
            });
        }, 7500);
    }

    stopRefresher(): void {
        this.$interval.cancel(this.refresher);
        this.refresher = undefined;
    }
}
